export default __webpack_public_path__ + "static/media/new-fund-icon.d317d9a4.svg";